module.exports = __webpack_public_path__ + "img/Bridge1-test-1.5f34af55.svg";